<template>
	<div class="main_body_goods_list">
		<!-- 存在商品参数时 -->
		<el-row :gutter="15" v-if="goods">
			<el-col :span="6" v-for="(item, index) in goodsList" :key="index">
				<div :class="[
				        'center-goods-box',
				        {'hover-box': enter_index === index}
				    ]" @mouseenter="handleMove(index)" @mouseleave="handleMove(-1)">
					<el-card shadow="hover">
						<div class="goods_item">
							<!-- 图片 -->
							<div class="goods_img">
								<img-loading :src="item.goods_images[0]"
									:href="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}">
								</img-loading>
							</div>
							<!-- 文字描述 -->
							<div class="goods_introduction">
								<!-- 标题 -->
								<router-link
									:to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}"
									class="goods_title">
									{{item.goods_name}}
								</router-link>
								<!-- 副标题 -->
								<p class="goods_subtitle">{{item.goods_brief}}</p>
								<!-- 价格 -->
								<p class="goods_price" v-if="show_price && powerPrice">
									<span>{{currency}}</span>
									<span>{{item.shop_price}}</span>
								</p>
							</div>
						</div>
					</el-card>
					<!-- 收藏按钮 -->
					<div v-if="power.includes(17) || power.includes(0) || power.includes(111)" :class="[
				            'center-goods-collection',
				            {'is-collection':item.collection>0}
				        ]">
						<a href="javascript:;" @click="handleCollection(item)">
							<i class="glyphicon glyphicon-heart-empty"></i>
						</a>
					</div>
				</div>
			</el-col>
			<el-col :span="6" v-if="!showMore">
				<div class="main_body_goods_list_more" v-if="more">
					<el-card shadow="hover">
						<div class="main_body_goods_list_more_img">
							<img-loading :src="more.goods_images[0]"
								:href="{name: 'pdetail', query:{id: more.goods_id},params:{cate_id:more.cat_id}}">
							</img-loading>
						</div>
					</el-card>
					<el-card shadow="hover" :body-style="{ padding: 0 }">
						<router-link :to="{name:'plist',query:{ id: parentId }}" class="main_body_goods_list_to_more">
							<img v-lazy="require('@/assets/img/images/content-top_icon02.png')" alt="">
						</router-link>
					</el-card>
				</div>
			</el-col>
		</el-row>
		<!-- 没有商品参数时 -->
		<div class="main_body_goods_list_nomore" v-else>
			{{$t("message.main.nothing")}}
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapGetters
	} from "vuex";

	export default {
		props: ["goods", "showMore", "parentId"],
		data() {
			return {
				enter_index: -1
			}
		},
		computed: {
			more() {
				return this.goods.slice(-1)[0];
			},
			goodsList() {
				if (this.goods.length) {
					if (this.showMore) {
						return this.goods;
					} else {
						return this.goods.slice(0, -1);
					}
				}
			},
			...mapState({
				currency: state => state.currency,
				show_price: state => state.show_price,
				power: state => state.user.power,
			}),
			...mapGetters([
				'powerPrice',
			])
		},
		components: {
			imgLoading: () => import("@/components/imgLoading")
		},
		methods: {
			...mapActions([
				"requestCollection",
				"getMainGoods"
			]),
			handleMove(val) {
				this.enter_index = val;
			},
			handleCollection(goods) { // 收藏操作
				// console.log(goods)
				let {
					goods_id,
					goods_sn,
					goods_name
				} = goods;
				this.requestCollection({
					goods_id,
					goods_sn,
					goods_name
				}).then((res) => {
					if (res == 1) {
						this.$message({
							showClose: true,
							message: this.$t("message.plist.collection3"),
							type: 'success'
						})
						this.getMainGoods();
					} else if (res == 3) {
						
						this.$message({
							showClose: true,
							message: this.$t("message.plist.collection4"),
							type: 'success'
						})
						this.getMainGoods();
					}
				})
			}
		}
		
	}
</script>

<style scoped>
	/* 商品盒子 */
	.center-goods-box {
		position: relative;
	}

	.hover-box>.center-goods-collection {
		z-index: 3;
		opacity: 0.8;
	}

	.hover-box>.center-goods-collection:hover {
		background: #ff6700;
	}

	/* 收藏盒子 */
	.center-goods-collection {
		position: absolute;
		top: 15px;
		right: 15px;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-color: #909399;
		opacity: 0;
		transition: all 0.2s linear;
		z-index: -1;
	}

	.center-goods-collection>a {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: block;
		color: #fff;
	}

	.center-goods-collection i {
		line-height: normal;
		font-size: 30px;
	}

	/* 已收藏样式 */
	.is-collection {
		background-color: transparent !important;
		opacity: 1;
		z-index: 100;
	}

	.is-collection>a {
		color: #ff6700;
	}










	/* 每个商品容器下边距 */
	.el-col {
		margin-bottom: 10px;
	}

	/* 商品容器 */
	.goods_item {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 250px;
	}

	/* 商品图片容器样式 */
	.goods_item>.goods_img {
		position: relative;
	}

	.goods_item>.goods_img::before {
		display: block;
		content: "";
		padding-top: 90%;
	}

	/* 改写子组件样式 */
	.goods_item>.goods_img>>>a {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	/* 文字描述 */
	.goods_item>.goods_introduction {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		margin-top: 6px;
	}

	/* 标题样式 */
	.goods_item>.goods_introduction>.goods_title {
		display: block;
		color: #333;
		font-size: 14px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	/* 副标题样式 */
	.goods_item>.goods_introduction>.goods_subtitle {
		width: 100%;
		color: #b0b0b6;
		font-size: 12px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	/* 价格样式 */
	.goods_item>.goods_introduction>.goods_price {
		color: #ff6709;
		font-size: 12px;
	}

	/* 查看更多处商品 */
	.main_body_goods_list_more>.el-card {
		margin-bottom: 8px;
	}

	/* 最后一项图片 */
	.main_body_goods_list_more_img {
		height: 100px;
	}

	/* 查看更多 */
	.main_body_goods_list_to_more {
		display: block;
		height: 140px;
		line-height: 140px;
	}

	.main_body_goods_list_to_more>img {
		max-width: 100%;
	}

	/* 暂无更多商品样式 */
	.main_body_goods_list_nomore {
		text-align: center;
		height: 596px;
		line-height: 596px;
		background: #fff;
	}
</style>
